export abstract class Anys {
  static isNullOrUndef<T>(val: T | null | undefined): val is null | undefined {
    if (typeof val === 'undefined') {
      return true;
    }

    return val === null;
  }

  static notNullOrUndef<T>(val: T | null | undefined): val is T {
    return Anys.isNullOrUndef(val) === false;
  }
}
